import { call, put, all, takeLatest, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import api from '../../../services/api'; // eslint-disable-line
import { boxesSuccess, boxesFailure } from './actions';
import { BoxesTypes } from './types';
import { mockBoxesData } from '../../../utils/mockBoxesData';
import { computeProfitAndLoss, computeWinAndLoss, computeGoalsProgress } from '../../../utils/boxCalculations';

export function* getBalanceAndBoxesData() {
  try {
    var hasDemoData = yield select(function(state: any) { return state.user.user.hasDemoData; });
    if (hasDemoData) {
      yield put(boxesSuccess(mockBoxesData));
      return;
    }

    const timeZoneDate = new Date();
    const offsetHours = timeZoneDate.getTimezoneOffset() / 60;
    const response = yield call(api.get, `/boxes/${offsetHours}`);
    const { boxes } = response.data;

    // Compute ProfitAndLoss and WinAndLoss from DailyCalendar on the frontend
    const dailyCalendar = boxes.DailyCalendar || [];
    boxes.ProfitAndLoss = computeProfitAndLoss(dailyCalendar, offsetHours);
    boxes.WinAndLoss = computeWinAndLoss(dailyCalendar, offsetHours);

    // Compute Goals progress from DailyCalendar
    if (boxes.Goals) {
      const progress = computeGoalsProgress(dailyCalendar, offsetHours);
      boxes.Goals = {
        ...boxes.Goals,
        ...progress,
      };
    }

    yield put(boxesSuccess(boxes));
  } catch (err) {
    toast.error(err.response.message, {
      toastId: 'homeError',
    });

    yield put(boxesFailure());
  }
}

export default all([
  takeLatest(BoxesTypes.BOXES_REQUEST, getBalanceAndBoxesData),
]);
